/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface AblyAuthSchema
 */
export interface AblyAuthSchema {
  /**
   *
   * @type {string}
   * @memberof AblyAuthSchema
   */
  capability: string;
  /**
   *
   * @type {string}
   * @memberof AblyAuthSchema
   */
  clientId: string;
  /**
   *
   * @type {number}
   * @memberof AblyAuthSchema
   */
  expires: number;
  /**
   *
   * @type {number}
   * @memberof AblyAuthSchema
   */
  issued: number;
  /**
   *
   * @type {string}
   * @memberof AblyAuthSchema
   */
  keyName: string;
  /**
   *
   * @type {string}
   * @memberof AblyAuthSchema
   */
  token: string;
}

/**
 * Check if a given object implements the AblyAuthSchema interface.
 */
export function instanceOfAblyAuthSchema(
  value: object,
): value is AblyAuthSchema {
  if (!('capability' in value) || value['capability'] === undefined)
    return false;
  if (!('clientId' in value) || value['clientId'] === undefined) return false;
  if (!('expires' in value) || value['expires'] === undefined) return false;
  if (!('issued' in value) || value['issued'] === undefined) return false;
  if (!('keyName' in value) || value['keyName'] === undefined) return false;
  if (!('token' in value) || value['token'] === undefined) return false;
  return true;
}

export function AblyAuthSchemaFromJSON(json: any): AblyAuthSchema {
  return AblyAuthSchemaFromJSONTyped(json, false);
}

export function AblyAuthSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AblyAuthSchema {
  if (json == null) {
    return json;
  }
  return {
    capability: json['capability'],
    clientId: json['clientId'],
    expires: json['expires'],
    issued: json['issued'],
    keyName: json['keyName'],
    token: json['token'],
  };
}

export function AblyAuthSchemaToJSON(value?: AblyAuthSchema | null): any {
  if (value == null) {
    return value;
  }
  return {
    capability: value['capability'],
    clientId: value['clientId'],
    expires: value['expires'],
    issued: value['issued'],
    keyName: value['keyName'],
    token: value['token'],
  };
}
